import { Wrap, WrapProps } from "@chakra-ui/react"

import { selectPortalStatistics, useDappSelector } from "#/redux-state"
import { usePortalStatistics, useStatistics } from "#/shared/hooks"
import { separateThousandsWithComma } from "#/shared/utils"

import PortalDataBox from "./PortalDataBox"

export default function PortalData(props: WrapProps) {
  useStatistics()

  const statistics = useDappSelector(selectPortalStatistics)
  const { convertedTVL, convertedDeposits } = usePortalStatistics()

  return (
    <Wrap minH="131px" p="0 10px 10px" spacing={3} {...props}>
      <PortalDataBox
        background="#E4DFAA"
        color="#726907"
        label="Mezo HODLers"
        data={
          statistics ? separateThousandsWithComma(statistics.hodlers, 0) : null
        }
      />
      <PortalDataBox
        background="#C3D876"
        color="#566327"
        label="TVL"
        data={convertedTVL ? `$${convertedTVL}` : null}
      />
      <PortalDataBox
        background="#72C0BD"
        color="#045350"
        label="Bitcoin deposited"
        data={convertedDeposits ? `₿ ${convertedDeposits}` : null}
      />
      <PortalDataBox
        background="#F1A91F"
        color="#6E4108"
        label="Bitcoin price today"
        data={
          statistics
            ? `${
                Number(statistics.usdPerBtc24hChange) < 0 ? "↘" : "↗︎"
              } ${Number(statistics.usdPerBtc24hChange).toFixed(2)}%`
            : null
        }
      />
    </Wrap>
  )
}
